import React from 'react';
import FeatureButton from './FeatureButton';
import AppFeatures from '../AppFeatures';

interface HandleCompleteOrderProps {
  handleCompleteOrderWarehouse: (completed: boolean) => void;
  featureValidator: (features:AppFeatures[]) => boolean;
}

const HandleCompleteOrder: React.FC<HandleCompleteOrderProps> = ({handleCompleteOrderWarehouse, featureValidator}) => {
  return (
    <>
      <FeatureButton
        variant="contained"
        color="success"
        onClick={() => handleCompleteOrderWarehouse(true)}
        fullWidth
        className="popup-button"
        features={[AppFeatures.CompleteOrder]}
        featureValidator={featureValidator}
      >
        Complete order
      </FeatureButton>
      <FeatureButton
        variant="contained"
        color="error"
        onClick={() => handleCompleteOrderWarehouse(false)}
        fullWidth
        className="popup-button"
        features={[AppFeatures.CompleteOrder]}
        featureValidator={featureValidator}
      >
        Deny order completion
      </FeatureButton>
    </>
  );
};

export default HandleCompleteOrder;
